module.exports = __webpack_public_path__ + "static/media/heart.7672e06a.svg";